/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SaveCredsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {SaveCredsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const saveCreds = (request: SaveCredsRequest, options?: CashRequestOptions) => post<SaveCredsRequest, SaveCredsResponse>("/2.0/cash/save-creds", request, {...options, rejectOnError: true })